<template>
    <hts-drawer
        v-model="visible"
        :title="$t('labels.addCosting')"
        :rules="rulesCostingInformation"
        :submit="submit"
        size="large"
        @close="close">
        <hts-card :title="$t('labels.generalInformation')">
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-5">
                <hts-form-input
                    v-model="formData.name"
                    :label="$t('labels.costingName')"
                    required
                    prop="costingName"
                    name="costingName"
                    :color="props.color" />

                <hts-form-select
                    v-model="formData.typeCommodity"
                    :label="$t('labels.typeCommodity')"
                    :items="typeCommodity"
                    key-id="key"
                    key-label="title"
                    required
                    prop="typeCommodity"
                    name="typeCommodity" />
            </div>
        </hts-card>

        <hts-card :title="$t('labels.cost')">
            <hts-form-checkbox
                v-model="formData.targets"
                :label="$t('labels.priceTarget')"
                :items="targets"
                required
                prop="priceTarget"
                name="priceTarget"
                check-key="key"
                check-label="title" />

            <hts-ui-tabs
                v-if="priceTargets && priceTargets.length"
                v-model="selectPriceTargets"
                :tabs="priceTargets"
                key-id="id" />

            <div>
                <template v-for="t in formData.targets || []">
                    <div
                        v-if="t === selectPriceTargets"
                        :key="t">
                        <template v-if="t === 'VEHICLE'">
                            <hts-form-radio
                                v-model="formData.prices[t].calculatedType"
                                :label="$t('labels.calculatedType')"
                                :items="calculatedType"
                                required
                                value-key="key"
                                label-key="title" />

                            <div class="overflow-x-scroll pb-2">
                                <div
                                    v-for="(priceTarget, index) in formData.prices[t].priceDetails"
                                    :key="priceTarget"
                                    class="flex gap-2"
                                    :style="{ minWidth: minWidthScroll }">
                                    <hts-form-select
                                        v-if="CContTypes[t].length"
                                        v-model="priceTarget.type"
                                        :label="$t('labels.vehicleType')"
                                        :items="CContTypes[t][index]"
                                        key-id="_id"
                                        key-label="name"
                                        multiple
                                        required
                                        class="w-[50%]" />

                                    <hts-form-input
                                        v-model="priceTarget.amount"
                                        type="number"
                                        :label="$t('labels.money')"
                                        required
                                        name="money"
                                        :prop="`VEHICLE_${index}`"
                                        class="w-[50%]" />

                                    <hts-form-button
                                        class="mt-12 w-[50px]"
                                        color="error"
                                        size="mini"
                                        @click="deleteCosts(t, index)">
                                        {{ $t('labels.delete') }}
                                    </hts-form-button>
                                </div>
                            </div>
                        </template>

                        <template v-if="t === 'REMOOC'">
                            <hts-form-radio
                                v-model="formData.prices[t].calculatedType"
                                :label="$t('labels.calculatedType')"
                                :items="calculatedType"
                                required
                                value-key="key"
                                label-key="title" />

                            <div class="overflow-x-scroll pb-2">
                                <div
                                    v-for="(priceTarget, index) in formData.prices[t].priceDetails"
                                    :key="priceTarget"
                                    class="flex gap-2"
                                    :style="{ minWidth: minWidthScroll }">
                                    <hts-form-select
                                        v-model="priceTarget.type"
                                        :label="$t('labels.typeMooc')"
                                        :items="CContTypes[t][index]"
                                        key-id="key"
                                        key-label="title"
                                        multiple
                                        required
                                        class="w-[50%]" />

                                    <hts-form-input
                                        v-model="priceTarget.amount"
                                        type="number"
                                        :label="$t('labels.money')"
                                        required
                                        name="money"
                                        :prop="`REMOOC_${index}`"
                                        class="w-[50%]" />

                                    <hts-form-button
                                        class="mt-12 w-[50px]"
                                        color="error"
                                        size="mini"
                                        @click="deleteCosts(t, index)">
                                        {{ $t('labels.delete') }}
                                    </hts-form-button>
                                </div>
                            </div>
                        </template>

                        <template v-if="t === 'CONT'">
                            <hts-form-radio
                                v-model="formData.prices[t].calculatedType"
                                :label="$t('labels.calculatedType')"
                                :items="calculatedType"
                                required
                                value-key="key"
                                label-key="title" />

                            <div class="overflow-x-scroll pb-2">
                                <div
                                    v-for="(priceTarget, index) in formData.prices[t].priceDetails"
                                    :key="priceTarget"
                                    class="flex gap-2"
                                    :style="{ minWidth: minWidthScroll }">
                                    <hts-form-select
                                        v-model="priceTarget.type"
                                        :label="$t('labels.containerType')"
                                        :items="CContTypes[t][index]"
                                        key-id="key"
                                        key-label="title"
                                        filterable
                                        multiple
                                        required
                                        class="w-[50%]" />

                                    <hts-form-input
                                        v-model="priceTarget.amount"
                                        type="number"
                                        :label="$t('labels.money')"
                                        required
                                        name="money"
                                        :prop="`CONT_${index}`"
                                        class="w-[50%]" />

                                    <hts-form-button
                                        class="mt-12 w-[50px]"
                                        color="error"
                                        size="mini"
                                        @click="deleteCosts(t, index)">
                                        {{ $t('labels.delete') }}
                                    </hts-form-button>
                                </div>
                            </div>
                        </template>

                        <hts-form-button
                            class="mt-5"
                            color="main"
                            icon-name="hi-plus-circle-icon"
                            icon-position="right"
                            @click="addCosts(t)">
                            {{ $t('labels.add') }}
                        </hts-form-button>
                    </div>
                </template>
            </div>
        </hts-card>

        <hts-modal
            :show="showChangeTarget"
            :title="titleChangeTarget"
            type="confirm"
            :content="detailChangeTarget"
            @hide="cancelChangeTarget"
            @confirm="handleChangeTarget" />
    </hts-drawer>
</template>

<script setup lang="ts">
import { ICreateCosting } from '~/pages/trucker-[id]/cost/-component/imports/form'

import screen from '~/components/utils/screen'

const breakpoint = screen()
const minWidthScroll = computed(() => {
  return `${breakpoint.value.thresholds.sm}px`
})

const visible = ref(false)
const selectPriceTargets = ref('')
const vehicleCategories = ref<{ [key: string]: any }[]>([])

const showChangeTarget = ref<boolean>(false)
const titleChangeTarget = ref<string>('')
const detailChangeTarget = ref<string>('')
const handleChangeTarget = ref<any>()
const cancelChangeTarget = ref<any>()

const props = defineProps({
  codeCooperator: {
    type: String,
    default: ''
  }
})
const resetForm = () => {
  Object.assign(formData, {
    name: '',
    typeCommodity: 'NORMAL',
    targets: [],
    prices: {
      VEHICLE: {
        calculatedType: null,
        priceDetails: [
          {
            type: null,
            amount: null
          }
        ]
      },
      REMOOC: {
        calculatedType: null,
        priceDetails: [
          {
            type: null,
            amount: null
          }
        ]
      },
      CONT: {
        calculatedType: null,
        priceDetails: [
          {
            type: null,
            amount: null
          }
        ]
      }
    }
  } as ICreateCosting)
}
const formData = reactive<ICreateCosting>({
  name: '',
  typeCommodity: 'NORMAL',
  targets: [],
  prices: {
    VEHICLE: {
      calculatedType: null,
      priceDetails: [
        {
          type: null,
          amount: null
        }
      ]
    },
    REMOOC: {
      calculatedType: null,
      priceDetails: [
        {
          type: null,
          amount: null
        }
      ]
    },
    CONT: {
      calculatedType: null,
      priceDetails: [
        {
          type: null,
          amount: null
        }
      ]
    }
  }
})
const close = () => {
  visible.value = false
}

const emits = defineEmits(['refreshTables'])

const open = async () => {
  visible.value = true
  await getVehicleCategory()
}
defineExpose({
  open
})

const submit = async () => {
  const api = {
    url: '/costing/create',
    method: 'post'
  }
  const data: any = await $api(api, { body: formData })
  const resData = data?.data?.value
  if (resData?.success) {
    resetForm()
    process.client && $toast().success($t('labels.addCostingSuccess'))
    close()
    emits('refreshTables')
  }
}

const priceTargets = computed(() => {
  const tabs: any = []
  const keyTypes: any = []
  if (formData.targets?.includes('VEHICLE')) {
    tabs.push({
      id: 'VEHICLE',
      label: $t('labels.vehicle')
    })
    keyTypes.push('VEHICLE')
  }

  if (formData.targets?.includes('REMOOC')) {
    tabs.push({
      id: 'REMOOC',
      label: $t('labels.mooc')
    })
    keyTypes.push('REMOOC')
  }

  if (formData.targets?.includes('CONT')) {
    tabs.push({
      id: 'CONT',
      label: $t('labels.supplyList.container')
    })
    keyTypes.push('CONT')
  }

  if (!keyTypes.length) {
    selectPriceTargets.value = ''
  } else if (!keyTypes.includes(selectPriceTargets.value)) {
    selectPriceTargets.value = keyTypes[0]
  }

  return tabs
})

const addCosts = (type: string) => {
  if (!formData.prices[type]) {
    formData.prices[type] = {
      calculatedType: null,
      priceDetails: [
        {
          type: null,
          amount: null
        }
      ]
    }
    return
  }

  if (!formData.prices[type].priceDetails) {
    formData.prices[type].priceDetails = [
      {
        type: null,
        amount: null
      }
    ]

    return
  }

  formData.prices[type].priceDetails.push({
    type: null,
    amount: null
  })
}

const deleteCosts = (type: string, index: number) => {
  if (!formData.prices[type].priceDetails?.length || formData.prices[type].priceDetails.length === 1) {
    formData.prices[type].priceDetails = [
      {
        type: null,
        amount: null
      }
    ]
    return
  }

  if (index >= 0 && index < formData.prices[type].priceDetails.length) {
    formData.prices[type].priceDetails.splice(index, 1)
  }
}

watch(
  () => ({ ...formData.targets }),
  (newVal, oldVal) => {
    if (!visible.value) {
      return
    }

    if (!Object.values(oldVal)?.includes('VEHICLE') && Object.values(newVal)?.includes('VEHICLE')) {
      selectPriceTargets.value = 'VEHICLE'
      return
    }

    if (!Object.values(oldVal)?.includes('REMOOC') && Object.values(newVal)?.includes('REMOOC')) {
      selectPriceTargets.value = 'REMOOC'
      return
    }

    if (!Object.values(oldVal)?.includes('CONT') && Object.values(newVal)?.includes('CONT')) {
      selectPriceTargets.value = 'CONT'
      return
    }

    if (Object.values(oldVal)?.includes('VEHICLE') && !Object.values(newVal)?.includes('VEHICLE')) {
      titleChangeTarget.value = $t('labels.deleteCostObjectVehicle')
      detailChangeTarget.value = $t('labels.detailDeleteCostObject')
      showChangeTarget.value = true
      cancelChangeTarget.value = () => actionCancelChangeTarget('VEHICLE')
      handleChangeTarget.value = () => actionAcceptChangeTarget('VEHICLE')
      return
    }

    if (Object.values(oldVal)?.includes('REMOOC') && !Object.values(newVal)?.includes('REMOOC')) {
      titleChangeTarget.value = $t('labels.deleteCostObjectRemooc')
      detailChangeTarget.value = $t('labels.detailDeleteCostObject')
      cancelChangeTarget.value = () => actionCancelChangeTarget('REMOOC')
      handleChangeTarget.value = () => actionAcceptChangeTarget('REMOOC')
      showChangeTarget.value = true
      return
    }

    if (Object.values(oldVal)?.includes('CONT') && !Object.values(newVal)?.includes('CONT')) {
      titleChangeTarget.value = $t('labels.deleteCostObjectCont')
      detailChangeTarget.value = $t('labels.detailDeleteCostObject')
      cancelChangeTarget.value = () => actionCancelChangeTarget('CONT')
      handleChangeTarget.value = () => actionAcceptChangeTarget('CONT')
      showChangeTarget.value = true
    }
  },
  { deep: true }
)

const actionCancelChangeTarget = (type: string) => {
  if (formData.targets?.includes(type)) {
    return
  }

  const keys: string[] = targets.map((item) => item.key)

  if (!keys.includes(type)) {
    return
  }

  if (!formData.targets) {
    formData.targets = [type]
  }

  formData.targets.push(type)

  showChangeTarget.value = false
}

const actionAcceptChangeTarget = (type: string) => {
  if (formData.targets?.includes(type)) {
    return
  }

  const keys: string[] = targets.map((item) => item.key)

  if (!keys.includes(type) || !formData.targets) {
    return
  }

  $lodash.remove(formData.targets, (i) => {
    return i === type
  })

  formData.prices[type] = {
    calculatedType: null,
    priceDetails: [
      {
        type: null,
        amount: null
      }
    ]
  }

  showChangeTarget.value = false
}

const targets = [
  {
    key: 'VEHICLE',
    title: $t('labels.vehicle')
  },
  {
    key: 'REMOOC',
    title: $t('labels.mooc')
  },
  {
    key: 'CONT',
    title: $t('labels.supplyList.container')
  }
]

const typeCommodity = [
  {
    key: 'NORMAL',
    title: $t('labels.ordinaryGoods')
  },
  {
    key: 'FROZEN',
    title: $t('labels.frozen')
  },
  {
    key: 'DANGEROUS',
    title: $t('labels.dangerousGoods')
  },
  {
    key: 'FRAGILE',
    title: $t('labels.fragileGoods')
  }
  // {
  //   key: 'LIQUID',
  //   title: $t('labels.liquid')
  // },
  // {
  //   key: 'GAS',
  //   title: $t('labels.gas')
  // },
  // {
  //   key: 'OVERWEIGHT',
  //   title: $t('labels.overweightCargo')
  // }  // ko xoá cmt
]

const calculatedType = [
  {
    key: 'MONTH',
    title: $t('labels.month')
  },
  {
    key: 'TRIP',
    title: $t('labels.journey')
  },
  {
    key: 'KM',
    title: $t('labels.km')
  }
]

const CContTypes = computed(() => {
  const types: any = {
    VEHICLE: [],
    REMOOC: [],
    CONT: []
  }

  formData.prices.VEHICLE.priceDetails.forEach((cost: any, indexC: number) => {
    const usedTypesHaveIndex = formData.prices.VEHICLE.priceDetails.map((item, index) => (indexC === index ? [] : item.type))
    const usedTypes = mergeArray(usedTypesHaveIndex)
    types.VEHICLE.push(vehicleCategories.value.filter((type) => !usedTypes.includes(type._id)) || [])
  })

  formData.prices.REMOOC.priceDetails.forEach((cost: any, indexC: number) => {
    const usedTypesHaveIndex = formData.prices.REMOOC.priceDetails.map((item, index) => (indexC === index ? [] : item.type))
    const usedTypes = mergeArray(usedTypesHaveIndex)
    types.REMOOC.push(contTypes.filter((type) => !usedTypes.includes(type.key)) || [])
  })

  formData.prices.CONT.priceDetails.forEach((cost: any, indexC: number) => {
    const usedTypesHaveIndex = formData.prices.CONT.priceDetails.map((item, index) => (indexC === index ? [] : item.type))
    const usedTypes = mergeArray(usedTypesHaveIndex)
    types.CONT.push(contTypes.filter((type) => !usedTypes.includes(type.key)) || [])
  })

  return types
})

const mergeArray = (arr: any) => {
  return arr
    .reduce((result: any, item: any) => {
      if (Array.isArray(item)) {
        return result.concat(item)
      }
      return result
    }, [])
    .filter((item: any) => item !== null)
}

const contTypes = [
  {
    key: '20F',
    title: $t('labels.20f')
  },
  {
    key: '40F',
    title: $t('labels.40f')
  },
  {
    key: '45F',
    title: $t('labels.45f')
  }
]

const rulesCostingInformation = computed(() => {
  const rules = {
    costingName: 'required'
  } as { [key: string]: string }

  ;['VEHICLE', 'REMOOC', 'CONT'].forEach((target) => {
    if (formData.targets?.includes(target)) {
      formData.prices?.[target]?.priceDetails.forEach((item: any, index: number) => {
        rules[`${target}_${index}`] = 'max_value:999999999999999|min_value:0'
      })
    }
  })

  return rules
})

onBeforeMount(async () => {
  await getVehicleCategory()
})

const getVehicleCategory = async () => {
  const api = $urlAdmin.vehicle.category.getAllList

  const res = await $api(api)
  const resData: any = res?.data?.value
  if (resData?.success) {
    if (resData.data) {
      vehicleCategories.value = resData.data || []
    }
  }
}
</script>
